import React from "react";
import closeIcon from "assets/images/sbs/tot-new/cross.png";

const CategoriesModal = ({ categories, setCategory, onCloseModal }) => {
  const handleCategoryClick = (category) => {
    setCategory(category);
    onCloseModal();
  };

  return (
    <div className="tot-category-modal-wrap">
      <div className="tot-category-modal">
        <div className="category-modal-flex">
          <h3>Categories</h3>
          <img src={closeIcon} alt="" onClick={onCloseModal} />
        </div>

        <div className="list-cnt">
          {categories.map((value, index) => (
            <p key={index} onClick={() => handleCategoryClick(value)}>
              {value}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoriesModal;
